import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Sidebar from 'components/shared/sidebar/component';
import { SIDEBAR_MODE_PLAYER } from 'components/constants';
import { websocketConnectAction } from '../../../../redux/actions/shared.actions';
export default function ViewHome() {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var token = useSelector(function (state) { return state.playerAuthorization.token; });
    var isLoggedInAsUser = useSelector(function (state) { return state.playerAuthorization.token || null; });
    useEffect(function () {
        if (token && !isLoggedInAsUser) {
            navigate('/dashboard');
            return;
        }
        if (isLoggedInAsUser) {
            navigate('/facilitator');
            return;
        }
        navigate('/token');
    }, [token, isLoggedInAsUser]);
    return (React.createElement("div", null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_PLAYER }),
        "Nothing here, sorry :("));
}
